export default "__VITE_ASSET__BlMRu_x3__"